import { createIcon } from "@chakra-ui/react";

// Source: https://fontawesome.com/icons/cactus?s=solid
export default createIcon({
  displayName: "Cactus",
  viewBox: "0 0 512 512",
  path: (
    <path
      d="M464 224c-26.5 0-48 21.5-48 47.1v63.1c0 8.875-7.125 15.1-16 15.1H352V101.4c0-51.1-38.88-98.5-90.88-101.2c-26.25-1.375-51.1 8.126-71.13 26.25C170.9 44.51 160 69.63 160 96v127.1L112 224c-8.875 0-16-7.125-16-15.1V144c0-26.5-21.5-47.1-48-47.1S0 117.5 0 144v63.1c0 61.87 50.12 111.1 112 111.1H160v159.1C160 497.6 174.4 512 192 512h128c17.62 0 32-14.37 32-31.1v-31.1h48c61.88 0 112-50.12 112-111.1V272C512 245.5 490.5 224 464 224zM224 176c-8.875 0-16-7.125-16-15.1S215.1 144 224 144S240 151.1 240 160C240 168.9 232.9 176 224 176zM288 400c-8.875 0-16-7.125-16-15.1c0-8.875 7.125-15.1 16-15.1s16 7.125 16 15.1C304 392.9 296.9 400 288 400z"
      fill="currentColor"
    />
  ),
});
